<template>
  <div class="zadi-books-page">
    <page-header title="كنوز زادي" />
    <infinite-scroll-wrapper @fetch-data="fetchAllBooks" :limit="limit" :total="total"
      :is-loading="isLoadingBooks">
      <template>
        <book-summary-mini v-for="book in books" :key="book.id" :book="book" />
      </template>
      <template v-if="isLoadingBooks">
        <book-summary-mini-skelton v-for="n in limit" :key="n" />
      </template>
    </infinite-scroll-wrapper>
  </div>
</template>

<script>
import PageHeader from "../components/shared/PageHeader.vue";
import BookSummaryMini from "../components/books/BookSummaryMini.vue";
import BookSummaryMiniSkelton from "../components/books/BookSummaryMiniSkelton.vue";
import InfiniteScrollWrapper from "../components/shared/InfiniteScrollWrapper.vue";
import booksRepository from "../repositories/booksRepository";

export default {
  metaInfo: {
    title: "مشروع زادي | كنوز زادي ",
  },
  components: { BookSummaryMini, BookSummaryMiniSkelton, PageHeader, InfiniteScrollWrapper },
  data() {
    return {
      books: [],
      isLoadingBooks: false,
      page: 1,
      limit: 4,
      total: null
    }
  },
  methods: {
    async fetchAllBooks({ page, limit }) {
      this.isLoadingBooks = true;
      const res = await booksRepository.getAllBooks(page, limit);
      this.books = [...this.books, ...res?.data?.data];
      this.total = res?.data?.pageCount;
      this.isLoadingBooks = false;
    },
    navigate() {
      this.$router.push({ name: 'ZadiBookDetails', params: { id: 1, } });
    },
  },
  async mounted() {
    await this.fetchAllBooks({
      page: this.page,
      limit: this.limit,
    })
  }
};
</script>

<style scoped>
.zadi-books-page {
  padding: 40px 40px 80px 40px;
}

@media (max-width: 560px) {
  .zadi-books-page {
    padding: 40px 20px 80px 20px;
  }
}
</style>
